module.exports = __webpack_public_path__ + "static/img/Josh-Papali'I.365315d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Papali'I.jpg
// module id = KOCf
// module chunks = 0